import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { WhyDidntWork } from './components/sections/WhyDidntWork';
import { Mechanism } from './components/sections/Mechanism';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { WhoFor } from './components/sections/WhoFor';
import { HowItWorks } from './components/sections/HowItWorks';
import { Proof } from './components/sections/Proof';
import { FAQ } from './components/sections/FAQ';
import { Offer } from './components/sections/Offer';
import { Footer } from './components/sections/Footer';
export function App() {
  useEffect(() => {
    document.title = 'The Menopause Belly Reset';
  }, []);
  return <main className="min-h-screen bg-wellness-cream font-sans text-wellness-forest" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <WhyDidntWork data-id="element-3" />
      <Mechanism data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <Offer data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}